<template>
	<AppButton
		variant="secondary"
		:icon="buttonIcon"
		aria-label="Meldingen"
		@click="open"
	/>
	<Teleport to="body">
		<AppModal v-if="showNotificationModal" @hide-modal="close">
			<template #header> {{ copy.notifications }} </template>
			<NotificationDisplay />
			<template #footer>
				<AppButton :disabled="!store.hasUnread" @click="store.readUnread">
					{{ copy.markAllAsRead }}
				</AppButton>
			</template>
		</AppModal>
	</Teleport>
</template>

<script lang="ts" setup>
import { useNotificationStore } from "@/store/useNotificationStore";
import { unreadNotificationsToast } from "@/helpers/toasts";
import { useRoute } from "vue-router";
import { computed, onMounted, ref, watch } from "vue";
import NotificationDisplay from "./NotificationDisplay.vue";

const copy = {
	notifications: "Meldingen",
	markAllAsRead: "Alles markeren als gelezen",
};

const route = useRoute();
watch(route, () => {
	showNotificationModal.value = false;
});

// TODO: decouple modal open/close from button
const store = useNotificationStore();
const showNotificationModal = ref(false);
const close = () => (showNotificationModal.value = false);
const open = async () => {
	showNotificationModal.value = true;
	await store.refresh();
};

// show toast message on mount if there are unread notifications
// TODO: decouple logic from this component
onMounted(() => {
	setTimeout(() => {
		if (store.hasUnread) {
			const count = store.unread.length;
			const callback = () => {
				showNotificationModal.value = true;
			};
			unreadNotificationsToast(count, callback);
		}
	}, 500);
});

const buttonIcon = computed(() =>
	store.hasUnread ? "notifications_unread" : "notifications",
);
</script>
